import { Money, formatMoney } from '@betterment/core';
import { HStack, Text, VStack } from '@betterment/samba-react';
import { ReturnsText } from '@betterment/shared-components';

import { DateRangeOption } from '../../../../../../../graphql/schema';
import { type PricePointType } from '../../pricePoints';
import { formattedTimeForDateRangeOption } from '../../timePeriods';

type PerformancePointHighlightSectionType = {
  highlight: PricePointType;
  latestPriceAmount: Money;
  latestReturnsAmount: Money;
  latestReturnsPercentage: number;
  dateRangeOption: DateRangeOption;
};

export const PerformancePointHighlightSection = ({
  highlight,
  latestPriceAmount,
  latestReturnsAmount,
  latestReturnsPercentage,
  dateRangeOption,
}: PerformancePointHighlightSectionType) => {
  const displayLatestPriceAmount = highlight?.amount ?? latestPriceAmount;
  const displayLatestReturnsAmount = highlight?.returns?.amount ?? latestReturnsAmount;
  const displayLatestReturnsPercentage = highlight?.returns?.percentage ?? latestReturnsPercentage;

  return (
    <VStack>
      <Text color="text" variant="text100">
        {formattedTimeForDateRangeOption(highlight.dateTime, dateRangeOption)}
      </Text>
      <Text variant="text400">{formatMoney(displayLatestPriceAmount, 'default')}</Text>
      <HStack css={{ gap: 'space.50', alignItems: 'center' }}>
        <ReturnsText
          variant="text100"
          negativeToken="text.critical"
          amount={displayLatestReturnsAmount}
          percent={displayLatestReturnsPercentage}
        />
      </HStack>
    </VStack>
  );
};
